import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../../Components/Modals/Loading/Loader";

import {
  ReporteAsistenciaCard,
  ReporteAsistenciaEmpleadoCard,
  FiltroReporteEmpleadosAsistencia as FiltroReportePermisosCard,
  FiltroDepartamentoReporteAsistenciaCard as FiltroDepartamentoReportePermisoCard,
} from "../../../Components/Cards";

import {
  fetchListaAsistencias,
  selectIsLoading,
  selectIsSuccess,
  selectListadoPonches,
  selectMessage,
  fetchListaAsistenciasExportar,
  fetchCambiarSuccess,
  fetchLimpiarAsistencia,
} from "../../../redux/Reportes/ReporteAsistenciasSlice";

import { fetchAllEmpleados } from "../../../redux/Empleados/EmpleadosSlice";

import { calcularAsistencia } from "../../../utils/calcularAsistencia";
import { Encabezado } from "../../../Components/Encabezado/Encabezado";
import { useForm } from "react-hook-form";

import swal from "sweetalert";

export const ReporteAsistenciaEmpleado = () => {
  
  // ? USE-SELECTOR
  const dispatch = useDispatch();
  const isSuccess = useSelector(selectIsSuccess);
  const message = useSelector(selectMessage);
  const listaEmpleadosPonches = useSelector(selectListadoPonches);
  const isLoading = useSelector(selectIsLoading);

  // ? USE-STATE
  // * HOOK-STATE QUE GUARDA LOS DATOS DEL EMPLEADO.
  const [empleado, setEmpleado] = useState({});

  // * HOOK-STATE DE LOS TOTALES.
  const [contadores, setContadores] = useState({
    totalAusencias: 0,
    totalLlegadaTarde: 0,
    totalSalidaTemprano: 0,
  });

  // ? HOOK-FORM
  const form = useForm({
    defaultValues: {
      filtroFechas: {
        desde: new Date(),
        hasta: new Date()
      }
    }
  });

  // ? HOOK-EFFECT
  useEffect(() => {
   
    if(isSuccess === 'success'){
      swal("Exitoso!", message, "success");
      dispatch(fetchCambiarSuccess());
      form.reset();
    }
    else if(isSuccess === 'error'){
      swal("Error", "Por favor, comunicarse con el departamento de Desarrollo e Implentación de Sistemas.", "error");
      dispatch(fetchCambiarSuccess());
    }

  }, [isSuccess])
  
  useEffect(() => {
    dispatch(fetchAllEmpleados());
  }, []);


  // * FUNCION QUE CAMBIA EL EMPLEADO.
  const nextEmpleado = (emp) => {
    setEmpleado(emp);
  };

  const searchReporteAsistencia = (filtro) => {
    dispatch(fetchListaAsistencias(filtro));
  };

  // * FUNCION QUE SOLICITA EL REPORTE DE ASISTENCIA EN FORMATO EXCEL.
  const ReporteAsistenciaExcel = (data) => {
    dispatch(fetchListaAsistenciasExportar(data));
  };

  // ? HOOK-EFFECT QUE CALCULA LA ASISTENCIA DE UN EMPLEADO SEGUN EL SELECCIONADO.
  useEffect(() => {
    if (Object.keys(empleado).length > 0) {
      calcularAsistencia(empleado, setContadores);
    }
  }, [empleado]);


  // * COMPROBACION DE QUE EXISTE UNO O MAS EMPLEADOS PARA MOSTRAR LAS OPCIONES CORRESPONDIENTES.
  const comprobacionEmpleados = listaEmpleadosPonches.length > 0 ? true : false;

  // * FUNCION PARA LIMPIAR FILTROS Y BUSQUEDA.
  const reset = () => {
    dispatch(fetchLimpiarAsistencia());
    form.reset();
  }

  return (
    <Encabezado title={"REPORTE DE ASISTENCIA"}>
       <div className="row">
            <div className="col-xl-6">
              <FiltroReportePermisosCard
                searchReporteAsistencia={searchReporteAsistencia}
                ReporteAsistenciaExcel={ReporteAsistenciaExcel}
                form={form}
                reset={reset}
              />
            </div>

            <div className="col-xl-6">
              {comprobacionEmpleados ? (
                <FiltroDepartamentoReportePermisoCard
                  listaEmpleadosPonches={listaEmpleadosPonches}
                  setEmpleado={nextEmpleado}
                  empleado={empleado}
                />
              ) : (
                <></>
              )}
            </div>

            <div className="col-xl-12">
              {comprobacionEmpleados ? (
                <ReporteAsistenciaEmpleadoCard empleado={empleado} />
              ) : (
                <></>
              )}
            </div>

            <div className="col-xl-12">
              {comprobacionEmpleados ? (
                <ReporteAsistenciaCard
                  empleado={empleado}
                  contadores={contadores}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
       

      {/* PANTALLA DE CARGA */}
      <Loading open={isLoading} />
    
    </Encabezado>
  );
};

export default ReporteAsistenciaEmpleado;
